<template>
  <div id="app">
    <!-- 遮罩层 -->
    <div v-if="isMobile" class="mask">
      <div class="mask-message">
        暂未适配移动端，<br>请于电脑端使用，谢谢合作！
      </div>
    </div>

    <!-- 顶部导航栏 -->
    <el-header class="header">
      <div class="logo" @click="goToHome">
        <el-image :src="pclogo" alt="Logo" style="width: 200px; height: 50px;" />
      </div>

      <!-- 顶部横向菜单 -->
      <el-menu mode="horizontal" class="menu" popper-append-to-body background-color="#fff" text-color="#333"
        active-text-color="#409EFF">
        <!-- 一级：分析视频 -->
        <el-menu-item index="1" @click="goToHome" style="font-size:18px">
          分析视频
        </el-menu-item>

        <!-- 一级：历史记录 -->
        <el-menu-item index="2" v-if="isLoggedIn" @click="goToHistory" style="font-size:18px">
          历史记录
        </el-menu-item>

        <!-- 一级：AI智能体 -->
        <el-menu-item index="3" v-if="isLoggedIn" @click="goToHSupper" style="font-size:18px">
          AI智能体
        </el-menu-item>

        <!-- 新增：矩阵管理（一级） -->
        <el-sub-menu index="4" v-if="isLoggedIn" trigger="hover">
          <!-- 一级标题 -->
          <template #title>
            <span style="font-size:18px">矩阵管理</span>
          </template>

          <!-- 二级：账号管理 -->
          <el-sub-menu index="4-1" trigger="hover">
            <template #title>账号管理</template>
            <!-- <el-menu-item index="4-1-2" @click="goToAccountGroup">
              账号分组
            </el-menu-item> -->
            <el-menu-item index="4-1-3" @click="goToAuthorizedAccount">
              授权账号
            </el-menu-item>
          </el-sub-menu>

          <!-- 二级：发布管理 -->
          <el-sub-menu index="4-2" trigger="hover">
            <template #title>发布管理</template>
            <!-- <el-menu-item index="4-2-1" @click="goToScheduledPublish">
              定时发布
            </el-menu-item> -->
            <el-menu-item index="4-2-2" @click="goToPublishingTask">
              发布任务
            </el-menu-item>
          </el-sub-menu>

          <!-- 二级：矩阵素材 -->
          <!-- <el-sub-menu index="4-3" trigger="hover">
            <template #title>矩阵素材</template>
            <el-menu-item index="4-3-1" @click="goToMaterialGroup">
              素材分组
            </el-menu-item>
            <el-menu-item index="4-3-2" @click="goToMaterialCenter">
              素材中心
            </el-menu-item>
          </el-sub-menu> -->
        </el-sub-menu>
      </el-menu>

      <!-- 用户信息/按钮 -->
      <div class="user-info" v-if="isLoggedIn">
        <span style="font-size:18px;margin-right:5px">
          积分：{{ userDianshu }}
        </span>
        <el-button @click="goToProfile" class="mine-button">个人中心</el-button>
        <el-button @click="confirmLogout" class="exit-button">退出登录</el-button>
      </div>
      <el-button v-else @click="goToLogin" class="login-button">登录</el-button>
    </el-header>

    <!-- 主体内容区 -->
    <el-main>
      <router-view />
    </el-main>
  </div>
</template>

<script>
import { ElMessageBox, ElMessage } from 'element-plus';
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import config from "@/config.js";

export default {
  data() {
    return {
      pointsInterval: null, // 定时器
      isTabletAgent: '',
      pclogo: null,         // Logo 图片
      isMobile: false,      // 是否为移动端
    };
  },
  computed: {
    // 从 Vuex 获取登录状态、积分和账号
    ...mapState(['isLoggedIn', 'userDianshu', 'account']),
  },
  watch: {
    // 监听登录状态变化，动态管理积分定时器
    isLoggedIn(newVal) {
      if (newVal) {
        this.updatePoints();
        this.pointsInterval = setInterval(this.updatePoints, 10000);
      } else {
        clearInterval(this.pointsInterval);
        this.pointsInterval = null;
      }
    },
  },
  mounted() {
    this.checkDevice();
    this.checkLoginStatus();
    this.fetchConfig();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeUnmount() {
    if (this.pointsInterval) clearInterval(this.pointsInterval);
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    ...mapActions(['login', 'logout']),

    checkDevice() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isPhoneAgent = /iphone|ipod|android.*mobile|blackberry|iemobile|opera mini/.test(userAgent);
      const isTabletAgent = /ipad|android(?!.*mobile)|tablet|playbook|silk|kindle|nexus 7|nexus 9/.test(userAgent);

      // 如果要让平板也当作桌面端，只认手机是 mobile
      this.isMobile = isPhoneAgent;

      // 如果想平板单独处理，也可以加一些逻辑
      if (isTabletAgent) {
        // do something for tablet
      }
    },



    // 检查登录状态
    checkLoginStatus() {
      const user = localStorage.getItem('user');
      if (user) {
        const userData = JSON.parse(user);
        this.login(userData);
      }
    },

    // 获取配置
    async fetchConfig() {
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/get_agent_info.php`, {
          agent_host: window.location.origin,
        });
        this.applyConfig(response.data);
      } catch (error) {
        ElMessage.error('配置加载失败');
      }
    },

    // 应用配置
    applyConfig(data) {
      if (data.pc_title) document.title = data.pc_title;
      if (data.pc_ico) this.setFavicon(data.pc_ico);
      if (data.pc_logo) this.pclogo = data.pc_logo;
    },

    // 设置浏览器图标
    setFavicon(iconUrl) {
      const link = document.querySelector('link[rel="icon"]') || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'icon';
      link.href = iconUrl;
      document.head.appendChild(link);
    },

    // 更新积分
    async updatePoints() {
      if (!this.account) {
        ElMessage.warning('账号信息缺失，无法获取积分');
        return;
      }
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/getUserPoints.php`, {
          account: this.account,
        });
        if (response.data.success) {
          this.$store.commit('setUserDianshu', response.data.data.dianshu);
        } else {
          ElMessage.error(response.data.error || '积分获取失败');
        }
      } catch (error) {
        ElMessage.error('网络错误，请稍后重试');
      }
    },

    // 路由跳转
    goToHome() {
      this.$router.push({ name: 'HomePage' });
    },
    goToHistory() {
      this.$router.push({ name: 'HistoryPage' });
    },
    goToHSupper() {
      this.$router.push({ name: 'SupperPage' });
    },
    goToProfile() {
      this.$router.push({ name: 'ProfilePage' });
    },
    goToLogin() {
      this.$router.push({ name: 'LoginPage' });
    },

    // 退出登录
    confirmLogout() {
      ElMessageBox.confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.logoutHandler();
        })
        .catch(() => {
          ElMessage.info('已取消退出');
        });
    },
    logoutHandler() {
      localStorage.removeItem('user');
      this.$store.dispatch('logout');
      this.$router.push({ name: 'LoginPage' });
    },

    // 二级、三级菜单对应的跳转
    goToAccountGroup() {
      console.log('账号分组被点击');
      this.$router.push({ name: 'AccountGroup' });
    },
    goToAuthorizedAccount() {
      console.log('授权账号被点击');
      this.$router.push({ name: 'AuthorizedAccount' });
    },
    goToScheduledPublish() {
      console.log('定时发布被点击');
      this.$router.push({ name: 'ScheduledPublish' });
    },
    goToPublishingTask() {
      console.log('发布任务被点击');
      this.$router.push({ name: 'PublishingTask' });
    },
    goToMaterialGroup() {
      console.log('素材分组被点击');
      this.$router.push({ name: 'MaterialGroup' });
    },
    goToMaterialCenter() {
      console.log('素材中心被点击');
      this.$router.push({ name: 'MaterialCenter' });
    },
  },
};
</script>

<style scoped>
/* 全局 */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}

/* 遮罩层 */
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.9), rgba(12, 12, 12, 0.8));
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: glow 2s infinite alternate;
}

@keyframes glow {
  0% {
    background: rgba(12, 12, 12, 0.7);
  }

  100% {
    background: rgba(0, 0, 0, 0.85);
  }
}

.mask-message {
  color: white;
  font-size: 18px;
  text-align: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
}

/* 头部导航栏 */
.header {
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  padding: 0 20px;
  border-bottom: 2px solid #e8e8e8;
  background-color: #fff;
}

.logo {
  flex: 0 0 auto;
  cursor: pointer;
  margin-right: 20px;
  margin-left: 280px;
}

.menu {
  flex: 1;
  text-align: center;
}

/* 用户信息 */
.user-info {
  margin-left: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-right: 280px;
}

.user-info span {
  white-space: nowrap;
}


/* 主体内容区 */
.el-main {
  padding: 20px;
}

/* 登录按钮 */
.login-button {
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
  color: white;
  padding: 20px 18px;
  border-radius: 5px;
  font-size: 16px;
  margin-right: 360px;
}

.login-button:hover {
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

/* 个人中心、退出按钮 */
.mine-button {
  padding: 20px 18px;
  border-radius: 5px;
  font-size: 16px;
}

.exit-button {
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  color: white;
  padding: 20px 18px;
  border-radius: 5px;
  font-size: 16px;
}
</style>
